import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/admin/layout.tsx");
